<template>
  <div style="color: white">
    <div class="info">
      <div v-if="!isExam || (isExam && currentExam && currentExam.modeCode === 4)">
        <div>{{ translationRange[0] }} ~ {{ translationRange[1] }}{{ $t('Common.colon') }}{{ $t('Vocabulary.examMode1') }}</div>
        <div>{{ listeningRange[0] }} ~ {{ listeningRange[1] }}{{ $t('Common.colon') }}{{ $t('Vocabulary.examMode2') }}</div>
      </div>
      <div v-else>
        <div>{{ currentExam.mode }}</div>
        <div></div>
      </div>
      <div>
        <div>下一題：[Tab]</div>
        <div>上一題：[Shift+Tab]</div>
      </div>
    </div>
    <div class="dash"></div>
    <vue-custom-scrollbar class="scroll-area" v-if="toStartTest">
      <div class="questions">
        <div v-for="(word, idx) in wordList" :key="idx">
          <div class="question">
            <div class="numbers">{{ idx+1 }}</div>
            <div v-if="!isExam || (isExam && currentExam && currentExam.modeCode === 4)">
              <div v-if="idx < wordList.length / 2" class="question-item">{{ word.meaning }}</div>
              <div v-else class="question-item">
                <b-icon-volume-up-fill @click="playAudio(word.us_pron)"></b-icon-volume-up-fill>
              </div>
            </div>
            <div v-else-if="isExam">
              <div
                v-if="currentExam && currentExam.modeCode === 1"
                class="question-item"
              >{{ word.meaning }}</div>
              <div v-else-if="currentExam && currentExam.modeCode === 2" class="question-item">
                <b-icon-volume-up-fill @click="playAudio(word.us_pron)"></b-icon-volume-up-fill>
              </div>
              <div v-else-if="currentExam && currentExam.modeCode === 3" class="question-item">
                {{ word.meaning }} &nbsp;
                <b-icon-volume-up-fill @click="playAudio(word.us_pron)"></b-icon-volume-up-fill>
              </div>
            </div>
            <div class="question-subitem">{{ word.part_of_speech }}</div>
          </div>
          <b-row v-if="idx===0" class="input-line">
            <!-- <b-col :cols="allowSpeechInput ? 11 : 12"> -->
            <b-col :cols="12">
              <input
                :id="`input${idx}`"
                :key="idx"
                :disabled="isRestTime"
                v-model="inputText[idx]"
                v-on:focus="onFocusInput(idx)"
                v-autofocus
                type="text"
                class="Input-text"
                onselectstart="return false;"
                onpaste="return false;"
                oncopy="return false;"
                oncut="return false;"
                ondrag="return false;"
                ondrop="return false;"
                autocomplete="off"
              />
            </b-col>
            <!-- <b-col v-if="allowSpeechInput" :cols="allowSpeechInput ? 1 : 0">
              <voice-input-button
                :appId="appId"
                :apiKey="apiKey"
                :apiSecret="apiSecret"
                v-model="result"
                @record="showResult"
                @record-start="recordStart(idx)"
                @record-stop="recordStop"
                @record-blank="recordNoResult"
                @record-failed="recordFailed"
                @record-ready="recordReady"
                @record-complete="recordComplete"
                interactiveMode="touch"
                color="#fff"
                tipPosition="top"
                language="en_us"
              >
                <template slot="no-speak">没听清您说的什么</template>
              </voice-input-button>
            </b-col> -->
          </b-row>
          <b-row v-else class="input-line">
            <!-- <b-col :cols="allowSpeechInput ? 11 : 12"> -->
            <b-col :cols="12">
              <input
              :id="`input${idx}`"
              :key="idx"
              :disabled="isRestTime"
              v-model="inputText[idx]"
              v-on:focus="onFocusInput(idx)"
              type="text"
              class="Input-text"
              onselectstart="return false;"
              onpaste="return false;"
              oncopy="return false;"
              oncut="return false;"
              ondrag="return false;"
              ondrop="return false;"
              autocomplete="off"
              spellcheck="false"
            />
            </b-col>
            <!-- <b-col v-if="allowSpeechInput" :cols="allowSpeechInput ? 1 : 0">
              <voice-input-button
                :appId="appId"
                :apiKey="apiKey"
                :apiSecret="apiSecret"
                v-model="result"
                @record="showResult"
                @record-start="recordStart(idx)"
                @record-stop="recordStop"
                @record-blank="recordNoResult"
                @record-failed="recordFailed"
                @record-ready="recordReady"
                @record-complete="recordComplete"
                interactiveMode="touch"
                color="#fff"
                tipPosition="top"
                language="en_us"
              >
                <template slot="no-speak">没听清您说的什么</template>
              </voice-input-button>
            </b-col> -->
          </b-row>
        </div>
      </div>
    </vue-custom-scrollbar>
    <div>
      <b-modal id="certificateAvailable" title="通知" ok-only no-close-on-backdrop no-close-on-esc>
        <p>{{ $t('Vocabulary.getYourCertificate') }}</p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'
// import voiceInputButton from 'voice-input-button2'
import SafeAudio from '../../../util/SafeAudio'
import Timer from '../../../util/Timer'
import { leading0 } from '../../../util/string'
import { MODES } from '../vocabularyMode'

export default {
  components: {
    vueCustomScrollbar
    // voiceInputButton
  },
  props: {
    isStarted: {
      type: Boolean,
      required: true
    },
    timer: {
      type: Timer,
      required: true
    }
  },
  directives: {
    autofocus: {
      inserted: function (el) {
        Vue.nextTick(() => el.focus())
      }
    }
  },
  data () {
    return {
      appId: process.env.VUE_APP_XUNFEI_APP_ID,
      apiKey: process.env.VUE_APP_XUNFEI_API_KEY,
      apiSecret: process.env.VUE_APP_XUNFEI_API_SECRET,
      inputText: [],
      currentIndex: 0,
      result: ''
    }
  },
  watch: {
    toStartTest (newValue, oldValue) {
      if (newValue !== oldValue && newValue === true) {
        this.inputText = new Array(this.wordList.length).fill('')
      }
    },
    isRestTime (newValue) {
      if (newValue === true) {
        this.timer.stopTimer()
      } else if (this.isStarted) {
        this.timer.startTimer()
      }
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      toStartTest: (state) => state.vocabularyPractice.toStartTest,
      wordList: (state) => state.vocabularyPractice.testWordList,
      isRestTime: (state) => state.studyOrBreak.isRestTime,
      mode: (state) => state.vocabularyPractice.mode,
      currentExam: (state) => state.exam.currentExam
      // allowSpeechInput: state => state.auth.currentUser.allowSpeechInput
    }),
    translationRange () {
      let range = [leading0(0, 2), leading0(0, 2)]
      if (this.wordList.length > 0) {
        range = [leading0(1, 2), leading0(Math.ceil(this.wordList.length / 2), 2)]
      }
      return range
    },
    listeningRange () {
      let range = [leading0(0, 2), leading0(0, 2)]
      if (this.wordList.length > 0) {
        range = [
          leading0(Math.ceil(this.wordList.length / 2) + 1, 2),
          leading0(this.wordList.length, 2)
        ]
      }
      return range
    },
    isExam () {
      return MODES.EXAM.includes(this.mode)
    }
  },
  methods: {
    // recordReady () {
    //   console.info('按钮就绪!')
    // },
    // recordStart (idx) {
    //   if (!this.allowSpeechInput) {
    //     return
    //   }
    //   console.info('录音开始')
    //   this.currentIndex = idx
    // },
    // showResult (text) {
    //   console.info('收到识别结果：', text)
    // },
    // recordStop () {
    //   console.info('录音结束')
    // },
    // recordNoResult () {
    //   console.info('没有录到什么，请重试')
    // },
    // recordComplete (text) {
    //   if (!this.allowSpeechInput) {
    //     return
    //   }
    //   if (this.inputText[this.currentIndex] === undefined) {
    //     this.inputText[this.currentIndex] = ''
    //   }
    //   console.log('inputText[0] 2:', this.inputText[0])
    //   console.info('识别完成! 最终结果：', text)
    //   text = text.replace('.', '').split(' ').join('').trim().toLowerCase()
    //   this.inputText[this.currentIndex] += text
    // },
    // recordFailed (error) {
    //   console.info('识别失败，错误栈：', error)
    // },
    playAudio (src) {
      const audio = new SafeAudio(src)
      audio.play()
      delete audio.audio
    },
    defaultPronunciation (word) {
      return word.us_pron && word.us_pron.length > 0
        ? word.us_pron
        : word.uk_pron
    },
    onFocusInput (idx) {
      this.currentIndex = idx

      if (this.isExam && this.currentExam) {
        if (
          this.currentExam.modeCode === 2 ||
          this.currentExam.modeCode === 3
        ) {
          this.playAudio(this.defaultPronunciation(this.wordList[idx]))
        } else if (this.currentExam.modeCode === 4) {
          if (idx >= this.wordList.length / 2) {
            this.playAudio(this.defaultPronunciation(this.wordList[idx]))
          }
        }
      } else if (!this.isExam) {
        if (idx >= this.wordList.length / 2) {
          this.playAudio(this.defaultPronunciation(this.wordList[idx]))
        }
      }
    },
    submit () {
      this.inputText = this.inputText.map((record) => {
        record = record.trim()
        return record
      })
      this.$store.dispatch('vocabularyPractice/uploadTestResult', {
        inputText: this.inputText,
        timeElapsed: this.timer.timeElapsed
      }).then((resolveValue) => {
        if (resolveValue === 'certificate available') {
          this.$bvModal.show('certificateAvailable')
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./styles/TestViewContent.scss";
</style>
